import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_TAGS_FILTER = 'UPDATE_TAGS_FILTER' as const;

export const updateTagsFilter = (tags: string[]) => ({ data: { tags }, type: UPDATE_TAGS_FILTER });

export type UpdateTagsFilterResponseAction = DataAction<typeof UPDATE_TAGS_FILTER, { tags: string[] }>;
